import router from '..'

export default function auth () {
  const token = localStorage.getItem('token')
  const idToken = localStorage.getItem('id_token')
  const expiresAt = localStorage.getItem('expires_at')
  const user = localStorage.getItem('user')
  
  // Verificar si tenemos todos los datos necesarios
  if (!user || !token || !idToken || !expiresAt) {
    router.push({ name: 'Login' })
    return false
  }
  
  // Verificar si el token ha expirado
  const now = Date.now()
  const expiration = parseInt(expiresAt)
  
  if (expiration < now) {
    // Token expirado, limpiar localStorage y redirigir a login
    localStorage.removeItem('token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('token_type')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('user')
    
    router.push({ name: 'Login' })
    return false
  }
  
  return true
}
